const baseConfig = {
    ...process.env, ...window['env']
}

export default baseConfig;

// const baseConfig = {
//     apiBaseUrl: 'https://gpu-beta-api.azurecapacityroadmap.com/api',
//     clientId: '236bf59f-88b0-4a71-b9ed-0c70af2931de',
//     authority: 'https://login.microsoftonline.com/common',
//     allowedDomains:['@microsoft.com', '@digisignals.com']
// }
// export default baseConfig;